/* eslint-disable pii/no-email */
export const CONTACTS_EXAMPLES = 'Apps/ContactsModule/Examples';

export const CONTACTS_SCREENS = 'Apps/ContactsModule/Screens';

export const AUTH_SCREENS = 'Apps/AuthModule/Screens';

export const AUTH_COMPONENTS = 'Apps/AuthModule/Components';

export const ONBOARDING_SCREENS = 'Apps/OnboardingModule/Screens';

export const CONTACTS_COMPONENTS = 'Apps/ContactsModule/Components';

export const SEGMENT_FILTER_GROUP = {
  contacts: 'Contacts',
  cpSystem: 'CP SISTEMA',
};

export const SEGMENT_PATH = '/v2/contacts/segments';
export const GROUP_PATH = '/v2/contacts/groups';

export const RADIO_BUTTON_NAME = 'senderRadioButtons';

export const DEFAULT_EMAIL_ADDRESS = 'defaultsender@mailingmktg.com';
